export function apiBaseUrl(): string {
  const url = process.env.NEXT_PUBLIC_API_BASE_URL;
  if (!url) return "https://portal.gmxtec.com";
  if (url === "http://localhost:4000") return url;
  return url.replace(/\/api$/, '');
}
